/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RiskMetric } from './RiskMetric';
import { RiskMetricFromJSON, RiskMetricFromJSONTyped, RiskMetricToJSON } from './RiskMetric';

/**
 *
 * @export
 * @interface PaginatedRiskMetricList
 */
export interface PaginatedRiskMetricList {
  /**
   *
   * @type {number}
   * @memberof PaginatedRiskMetricList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedRiskMetricList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedRiskMetricList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<RiskMetric>}
   * @memberof PaginatedRiskMetricList
   */
  results: Array<RiskMetric>;
}

/**
 * Check if a given object implements the PaginatedRiskMetricList interface.
 */
export function instanceOfPaginatedRiskMetricList(value: object): value is PaginatedRiskMetricList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedRiskMetricListFromJSON(json: any): PaginatedRiskMetricList {
  return PaginatedRiskMetricListFromJSONTyped(json, false);
}

export function PaginatedRiskMetricListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedRiskMetricList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(RiskMetricFromJSON),
  };
}

export function PaginatedRiskMetricListToJSON(value?: PaginatedRiskMetricList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(RiskMetricToJSON),
  };
}
